var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33041H9.16667",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99658 11.2503H12.4997",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 14.1668H4.99658",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0018 17.4989V10.8294M10.8299 2.4987L10.8364 2.50521M10.8364 2.50521L12.9102 4.57898L15.0018 2.48738V6.24634V10.8294M10.8364 2.50521L8.75635 4.58529L6.66976 2.4987C5.8549 3.31357 4.58317 4.58529 4.58317 4.58529L2.49658 2.4987V6.24634L2.49658 15.8315C2.49658 16.7523 3.24308 17.4989 4.16394 17.4989H15.8355C16.7563 17.4989 17.5028 16.7523 17.5028 15.8315V8.32837L15.0018 10.8294",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.588b9d6814583c5ae7b28cf04514a4f5.svg";
export { ForwardRef as ReactComponent };